import livestreamService from '../../services/livesession/LivestreamService';
import livestreamActions from '../../actions/LivestreamActions';
import P2PConnectionStore from '../../services/livesession/P2PConnectionStore';

const { liveSessionConnectionStatus } = livestreamActions;

// Maps the component state and props into deduced props, that way we keep testable logic outside of the component which
// stays really pure (status-free and service-free)
const mapStateToProps = (state, ownProps) => {
    const mainProctorId = livestreamService.resolveCallingProctor(state.livestream);
    const liveSessionTimestamp = livestreamService.resolveLiveSessionTimestamp(state.livestream, ownProps.proctorId);
    const connectionStatus = livestreamService.resolveConnectionStatus(state.livestream, ownProps.proctorId);
    const shouldShowProctor = ownProps.proctorId === mainProctorId;
    const shouldShowReconnecting = connectionStatus === liveSessionConnectionStatus.RECONNECTING;

    return {
        shouldShowProctor,
        remoteAudioStream: P2PConnectionStore.getRemoteAudioStream(ownProps.proctorId, liveSessionTimestamp),
        remoteWebcamStream: P2PConnectionStore.getRemoteWebcamStream(ownProps.proctorId, liveSessionTimestamp),
        shouldShowReconnecting,
        speakerDeviceId: state.livestream.speakerDeviceId,
    };
};

const proctorCallSelector = {
    mapStateToProps,
};

export default proctorCallSelector;
